<ng-container *transloco="let t; read: 'assignment'" >
    <section class="flex 2col justSpaceBetween">
      <div id="title mbs">
        <h1 *ngIf="!(assignment$ | async)?.id">{{t('detailView.title')}}</h1>
        <h1 *ngIf="(assignment$ | async)?.id">{{(assignment$ | async).title}}</h1>
    
        <h3 *ngIf="(assignment$ | async)?.specialNote" class="error">
          {{ t('hint') }}: {{(assignment$ | async)?.specialNote}}
        </h3>
      </div>
  
      
      <ng-container *permissionIf="'Permissions.TimeEntries.StartStopTimeEntry'">
        <app-time-tracking-start-stop
          *ngIf="(assignment$ | async)?.id"
          [assignment]="assignment$ | async"
          (onTimeEntryChange)="reloadAssignment()"
        ></app-time-tracking-start-stop>
      </ng-container>

    </section>

    <kendo-tabstrip>
        <kendo-tabstrip-tab [title]="t('general')" [selected]="true">
          <ng-template kendoTabContent>
            <app-assignment-detail></app-assignment-detail>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab
          *permissionIf="'Permissions.AssignmentServices.Search'"
          [title]="t('services')"
          [disabled]="!(assignment$ | async)?.id"
        >
          <ng-template kendoTabContent>
            <app-assignment-services></app-assignment-services>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab 
          *permissionIf="'Permissions.TimeEntries.Search'"
          [title]="t('timeEntries')"
          [disabled]="!(assignment$ | async)?.id"
        >
          <ng-template kendoTabContent>
            <app-assignment-time-entries></app-assignment-time-entries>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab 
          *permissionIf="'Permissions.SchedulerItems.Search'"
          [title]="t('scheduler')"
          [disabled]="!(assignment$ | async)?.id"
        >
          <ng-template kendoTabContent>
            <app-assignment-scheduler></app-assignment-scheduler>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab 
          *permissionIf="'Permissions.Attachments.Search'"
          [title]="t('attachments')"
          [disabled]="!(assignment$ | async)?.id"
        >
          <ng-template kendoTabContent>
            <app-attachments [assignmentId]="(assignment$ | async)?.id"></app-attachments>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab
          *permissionIf="'Permissions.Expenses.Search'"
          [title]="t('expenses')"
          [disabled]="!(assignment$ | async)?.id"
        >
          <ng-template kendoTabContent>
            <app-expense-assignment-list [assignment]="assignment$ | async"></app-expense-assignment-list>
          </ng-template>
        </kendo-tabstrip-tab>

        <kendo-tabstrip-tab 
          *permissionIf="'Permissions.Assignments.Analytics'"
          [title]="t('report')"
          [disabled]="!(assignment$ | async)?.id"
        >
          <ng-template kendoTabContent>
            <app-assignment-report></app-assignment-report>
          </ng-template>
        </kendo-tabstrip-tab>
    </kendo-tabstrip>
    <button 
        class="mts"
        kendoButton
        fillMode="solid"
        size="medium"
        rounded="medium"
        themeColor="primary"
        type="button"
        (click)="goBack()"
    >{{ t('goBackButton') }}
    </button>
</ng-container>